import { RootState } from 'rootReducer';

export const selectShouldShowTopLevelLoadingSpinner = (state: RootState) =>
  state.ui.apps.survey._shared.topLevelLoadingSpinner.shouldShowTopLevelLoadingSpinner;
